/** 鉴权域的 API 调用 */
import { apiFetch } from "@/lib/api-client";
import type { LoginResponse, LoginSuccess, PublicConfig, UserRole } from "@/types/api";

export interface LoginPayload {
  username: string;
  password: string;
}

export async function login(payload: LoginPayload): Promise<LoginResponse> {
  return apiFetch<LoginResponse>("/api/login", {
    method: "POST",
    body: JSON.stringify(payload),
    skipAuth: true,
  });
}

/** 登录页 / 注册页渲染需要的开关, 无需登录 */
export async function fetchPublicConfig(): Promise<PublicConfig> {
  return apiFetch<PublicConfig>("/api/config/public", { skipAuth: true });
}

export interface SendSmsPayload {
  phone: string;
  country_code?: string;
  purpose?: "login" | "register";
}

export interface SendSmsResponse {
  success: boolean;
  message: string;
  resend_interval_seconds: number;
}

export async function sendSms(p: SendSmsPayload): Promise<SendSmsResponse> {
  return apiFetch<SendSmsResponse>("/api/sms/send", {
    method: "POST",
    body: JSON.stringify(p),
    skipAuth: true,
  });
}

export interface SmsLoginPayload {
  phone: string;
  code: string;
  country_code?: string;
  invite_code?: string;
}

export async function loginSms(p: SmsLoginPayload): Promise<LoginResponse> {
  return apiFetch<LoginResponse>("/api/login/sms", {
    method: "POST",
    body: JSON.stringify(p),
    skipAuth: true,
  });
}

export interface SelectTenantPayload {
  ticket: string;
  user_id: number;
}

export async function selectTenant(p: SelectTenantPayload): Promise<LoginSuccess> {
  return apiFetch<LoginSuccess>("/api/login/select", {
    method: "POST",
    body: JSON.stringify(p),
    skipAuth: true,
  });
}

export interface RegisterPayload {
  phone: string;
  code: string;
  country_code?: string;
  company_name?: string;
  invite_code?: string;
  password?: string;
  username?: string;
  display_name?: string;
  email?: string;
}

export async function register(p: RegisterPayload): Promise<LoginSuccess> {
  return apiFetch<LoginSuccess>("/api/register", {
    method: "POST",
    body: JSON.stringify(p),
    skipAuth: true,
  });
}

export async function logout(): Promise<void> {
  // 后端会把 jti 列入黑名单, 失败也无所谓 (前端会清本地)
  try {
    await apiFetch("/api/logout", { method: "POST" });
  } catch {
    /* ignore */
  }
}

export interface MeResponse {
  id: number;
  username: string;
  display_name?: string;
  role: UserRole;
  company_id: number | null;
  company_name: string | null;
  last_login_at?: string | null;
  phone: string | null;
  email: string | null;
  has_password: boolean;
  company_type: "org" | "personal" | null;
  credits_enabled: boolean;
  credits_fen: number;
  /** 元 */
  credits: number;
  /** 本公司生效的计费单价 (分): 公司单独设置优先, 否则 .env 默认 */
  credit_price_quote_fen?: number;
  credit_price_image_fen?: number;
}

export async function fetchMe(): Promise<MeResponse> {
  return apiFetch<MeResponse>("/api/me");
}

export interface ChangePasswordPayload {
  old_password: string;
  new_password: string;
}

export async function changePassword(p: ChangePasswordPayload): Promise<{ success: boolean }> {
  return apiFetch<{ success: boolean }>("/api/me/change-password", {
    method: "POST",
    body: JSON.stringify(p),
  });
}
